export default __webpack_public_path__ + "static/media/leadership_bg.378c78f5.svg";